import React, { useState, useEffect } from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell, Modal, Box, Grid,
} from '@mui/material';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell, StyledButtonBlack
} from "../../styles/MyStyles";
import {GetEnumMenuItems} from "../../logic/EnumHelper";
import {GetTransferBankSides, GetTransferCryptoSides} from "../../logic/TrasferHelper";
import * as DataProvider from "../../logic/DataProvider";
import {CreateDataUpdateTicket} from "../../logic/TicketHelper";

const TransferRequestPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const isDeposit = location.pathname.includes('deposit');

    const [errors, setErrors] = useState({});

    const [wallets, setWallets] = useState([]);
    const [bankAccounts, setBankAccounts] = useState([]);

    const [showRedirectModal, setShowRedirectModal] = useState(false);

    const [request, setRequest] = useState({
        type: 0,
        accountId: '',
        amount: ''
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        try {
            let bundle = DataProvider.GetClientBundle();
            if (bundle.wallets) {
                let entities = bundle.wallets;
                setWallets(JSON.parse(JSON.stringify(entities)));
            }
            if (bundle.bankAccounts) {
                let entities = bundle.bankAccounts;
                setBankAccounts(JSON.parse(JSON.stringify(entities)));
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const validateForm = () => {
        let newErrors = {};

        if (request.type === '') {
            newErrors.type = 'Type is required.';
        }

        if (request.accountId === '') {
            newErrors.accountId = 'Account is required.';
        }

        if (request.amount === '') {
            newErrors.amount = 'Amount is required.';
        } else if (isNaN(request.amount)) {
            newErrors.amount = 'Amount must be number.';
        }

        return newErrors;
    };

    const handleFieldChange = (event) => {
        setRequest({
            ...request,
            [event.target.name]: event.target.value,
        });
    };

    const handleSendRequest = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            await CreateDataUpdateTicket(isDeposit ? 4 : 5, request);

            setShowRedirectModal(true);
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleCloseRedirectModal = (redirect) => {
        if (redirect) {
            navigate('/tickets');
        } else {
            handleGoBack()
        }
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {`New ${(isDeposit ? 'Deposit' : 'Withdrawal')} Request`}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSendRequest}>
                    Send request
                </StyledButtonOrange>
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Type</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="type"
                                label="Type"
                                select
                                value={request.type}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.type}
                                helperText={errors.type}
                            >
                                {GetEnumMenuItems('transferType')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Account</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="accountId"
                                label="Account"
                                select
                                value={request.accountId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.accountId}
                                helperText={errors.accountId}
                            >
                                {request.type === 0
                                    ? GetTransferCryptoSides(wallets)
                                    : GetTransferBankSides(bankAccounts)}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Amount</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="amount"
                                label="Amount"
                                value={request.amount}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.amount}
                                helperText={errors.amount}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            {showRedirectModal && (<Modal open={showRedirectModal} onClose={() => handleCloseRedirectModal(true)}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography variant="h6" component="h2">
                        This action creates a new Ticket, the status of which you can see in the Tickets section.
                    </Typography>
                    <Grid container spacing={2} marginTop={3}>
                        <Grid item xs={12} md={12}>
                            <StyledButtonOrange onClick={() => handleCloseRedirectModal(true)}>
                                Ok
                            </StyledButtonOrange>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>)}
        </Container>
    );
};

export default TransferRequestPage;
